export const ToggleListAbsolute = {
  template: `
  <div class="relative search-dropdown">
    <div class="w-full flex content-between search-dropdown-content">
      <div role="button" tabindex="0" :aria-expanded="show ? 'true' : 'false'" @keydown.enter.prevent.stop="display(component)" @keydown.space.prevent.stop="display(component)" @click.stop="display(component)" class="pl-3 p-2 lg:pl-3 lg:p-1 w-full text-dark overflow-hidden cursor-pointer search-dropdown-title">
        {{displayName}}
      </div>
      <div v-show="!show" @click.stop="display(component)"  class="cursor-pointer w-10  bg-white text-center px-3 pt-3 lg:px-3 lg:pt-3 list-advanced-off">
      <svg aria-hidden="true" focusable="false" viewBox="0 0 20 30"  class="w-3 h-3 fill-current text-light list-advanced-svg-off" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 11.5L0.25 22.3253V0.674683L19 11.5Z"/>
      </svg>
      </div>
      <div v-show="show" @click.stop="display(component)" class="cursor-pointer w-10 bg-primary pt-3 lg:px-3 lg:pt-3 px-3 border border-primary text-center list-advanced-on">
      <svg aria-hidden="true" focusable="false" viewBox="0 0 22 30" class="w-3 h-3 fill-current text-white list-advanced-svg-on" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.5 19L0.674683 0.25L22.3253 0.25L11.5 19Z" />
    </svg>
      </div>
    </div>
    <div @click.stop="" v-show="show" class="lg:absolute p-3 w-full z-50 bg-white border border-secondary h-auto max-h-[200px] overflow-y-auto search-dropdown-list">
      <div v-for="item in items" class="search-dropdown-item">
        <label class="custom-checkbox search-dropdown-label">
          {{$t(item)}}
          <input v-model="checked" class="search-dropdown-input" @change="toggle(component)" :key="item" type="checkbox" :value="item" :name="item" :checked="(selected.indexOf(item) != -1) ? true : false">
          <span class="checkmark"></span>
        </label>
      </div>
    </div>
  </div>
  `,
  data: function () {
      return {
        show: false,
        checked: [],
        displayName: this.title,
        uniqueInList: null,
        theme_directory: window.theme_directory,
      }
    },
    props: [
      'component',
      'title',
      'items',
      'selected',
      'collapse',
      'pivot',
    ],
    methods: {
      display(component){
        this.$emit('hideallcomponents', component);
        this.show = !this.show;
        this.$emit('update', {component, checked: this.checked})
        console.log("DISPLAY");
      },
      toggle(component){
        this.$emit('setpivot', component);

        if(this.checked.length == 0){
          this.$emit('unsetpivot', component);
        }
        this.$emit('updatechecked', {component, checked: this.checked})
        this.$emit('update', {component, checked: this.checked})

      },
    },
    watch: {
      checked: function (){
        if(this.checked.length > 0)
          this.displayName = this.checked.join(',');
        else
          this.displayName = this.title;
      },
      collapse: function(v){
        this.show = v
      },
      items: function (currentVal) {
        if(currentVal.length == 1)
        {
          this.uniqueInList = currentVal[0];
          this.checked = [];
          this.checked.push(this.uniqueInList);
        }
        else
        {
          if(!this.pivot)
            this.checked = []
        }
      },
    },
    computed: {
    },
}